import { render, staticRenderFns } from "./_wrapper.vue?vue&type=template&id=12f38049&scoped=true&lang=pug&"
import script from "./_wrapper.vue?vue&type=script&lang=js&"
export * from "./_wrapper.vue?vue&type=script&lang=js&"
import style0 from "./_wrapper.vue?vue&type=style&index=0&id=12f38049&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.9.5_snackhrvn2skq2fk5zrw2w5ryi/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12f38049",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/cj/Documents/Work/the-wedding/node_modules/.pnpm/vue-hot-reload-api@2.3.4/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('12f38049')) {
      api.createRecord('12f38049', component.options)
    } else {
      api.reload('12f38049', component.options)
    }
    module.hot.accept("./_wrapper.vue?vue&type=template&id=12f38049&scoped=true&lang=pug&", function () {
      api.rerender('12f38049', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/_common/_wrapper.vue"
export default component.exports